function templateTitle(slug: string) {
    return slug.replace(/[_-]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

export function prettyDescribeError(error: any): string {
    let errorMsg = '' + error;
    if (errorMsg.startsWith('{')) {
        const lastIndexClosingBrace = errorMsg.lastIndexOf('}');
        if (lastIndexClosingBrace < 0) {
            console.warn('prettyDescribeError: errorMsg does not have a closing brace', errorMsg);
            return errorMsg;
        }
        errorMsg = errorMsg.slice(0, lastIndexClosingBrace + 1);
        try {
            const jsonObj = JSON.parse(errorMsg);
            let str = '';
            Object.entries(jsonObj).map(([key, value]) => {
                str += `${templateTitle(key)}: ${value}`;
            }
            ).join('\n');
            return str;
        }
        catch (e) {
            console.warn('Error parsing json errorMsg.', errorMsg, '' + error);
            return errorMsg;
        }
    }
    return errorMsg;
}



/**
 * These characters should not produce any spaces in HTML output
 * (note: if it does, may have to clean up the hash suffix in output
 * eg.removeErrorTimeHashSuffix
 * for showErrorForm in withFormUtils.js
 */
const NULL_CHAR = '\u0000'; // null char also used at end of invisible character suffix as a marker of potential hash
const invisibleAlphabets = [
    NULL_CHAR, // Null character
    '\u200b', // Zero Width Space
    '\u200c', // Zero Width Non-Joiner
    '\u200d', // Zero Width Joiner
    '\u200e', // Left-To-Right Mark
    '\u200f', // Right-To-Left Mark
    '\u202a', // Left-To-Right Embedding
    '\u202b', // Right-To-Left Embedding
    '\u202c', // Pop Directional Formatting
    '\u202d', // Left-To-Right Override
    '\u202e', // Right-To-Left Override
    '\u2060', // Word Joiner
    '\u2061', // Function Application
    '\u2062', // Invisible Times
    '\u2063', // Invisible Separator
    '\u2064', // Invisible Plus
    '\u2065', // Invisible Minus
    '\u2066', // Left-to-Right Isolate
    '\u2067', // Right-to-Left Isolate
    '\u2068', // First Strong Isolate
    '\u2069', // Pop Directional Isolate
    '\u206e', // National Digit Shapes
    '\u206f', // Nominal Digit Shapes
    '\ufeff', // Zero Width No-Break Space (BOM)
];

function hashInteger(value: number, listOfCharacters: Array<string>, charsRequired: number) {
  // FNV-1a 32-bit hash
  let hash = 0x811c9dc5;
  for (let i = 0; i < 4; i++) {
    hash ^= (value >> (i * 8)) & 0xff;
    hash = (hash * 0x01000193) >>> 0;
  }
  // Encode hash using the character list
  const base = listOfCharacters.length;
  const result = [];
  let n = hash;
  for (let i = 0; i < charsRequired; i++) {
    result.push(listOfCharacters[n % base]);
    n = Math.floor(n / base);
  }
  return result.join('');
}

const MS_RESOLUTION_REPEATED_MSG_ALLOWED = 300;
const NUM_CHARS_HASH = 6; // Number of characters to genearate hash

function getErrorTimeHashSuffix() {
    return hashInteger(Math.floor(new Date().getTime()/MS_RESOLUTION_REPEATED_MSG_ALLOWED), invisibleAlphabets, NUM_CHARS_HASH)
       + NULL_CHAR;
}
/*
function removeErrorTimeHashSuffix(str: string) {
    if (str.endsWith(NULL_CHAR)) return str;

    // A naive assumption will be made that a null character at the end implies
    return str.slice(0, NUM_CHARS_HASH -1);

    // or replace against precomputed regex for non-naive approach
    //return str.replace(new RegExp(`(${invisibleAlphabets.join('|')})+$`), '');
}
*/

 /**
 * Create a unique string with 'random' invisible character suffix based off current milliseconds
 * time resolution added to string contents ,
 * to avoid matching string equalities
 * since that prevented repeated error messages from being displayed due to "no-change"
 * detected on error messages.
 * (Ideally, could had done an imperative appraoch to popping up alert boxes to avoid this issue!)
 * @param {string} str The string
 * @returns {String}
 */
export function newStringInstance(str: string) {
    return str + getErrorTimeHashSuffix();

}

// eslint-disable-next-line valid-jsdoc
/**
 * TOD: this function might deprecate particular with regards to use of Object.values,
 * temporarily used atm for backward compatability but not sure why
 * Is there any situation where error may be an an object?
 * @param {any} error The error to consider breaking into string or fragment of strings
 * @returns {any[] | string}
 */
export function mayObjValues<T>(error: T) {
    return typeof error === 'string' ? error :
        error instanceof String ? error.toString() :
        Object.values(error as { [key: string]: unknown });
}
